import Head from "next/head";
import { make as SetWrappedPage } from "../../../src/set-wrapped17/SetWrapped17Page.bs";

export default function Wrapped() {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=640px, maximum-scale=1" />
        <title>Set 17 Space Gods Wrapped - Teamfight Tactics</title>
      </Head>
      <SetWrappedPage />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
